// extracted by mini-css-extract-plugin
export var opportunitiesList = "bR_hK";
export var opportunitiesListContainer = "bR_hF";
export var opportunitiesListSearch = "bR_hG";
export var opportunitiesListSearchError = "bR_hJ";
export var opportunitiesListSearchInput = "bR_hH";